import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RecommendState {
    recTab: string;
    recTypeTab: string;
    selectedRecSortBy: string;
    dreamCollegeList: any[];
    targetCollegeList: any[];
    safeCollegeList: any[];
    shortListData: any[];
    recommendList: any[];
    courseList: any[];
    totalDreamCollegeList: number;
    totalTargetCollegeList: number;
    totalSafeCollegeList: number;
    totalCourseList: number;
    isLoading: boolean;
    hasMore: boolean;
    hasError: boolean;
    skipCount: number;
    addToListBtnHover: boolean;
    lowProfileStatus: boolean;
    profileStatus: number;
    profileLoaded: boolean;
    recommendDataFound: boolean;
}

const initialState: RecommendState = {
    recTab: 'college',
    recTypeTab: 'dream',
    selectedRecSortBy: 'popularity',
    dreamCollegeList: [],
    targetCollegeList: [],
    safeCollegeList: [],
    shortListData: [],
    recommendList: [],
    courseList: [],
    totalDreamCollegeList: 0,
    totalTargetCollegeList: 0,
    totalSafeCollegeList: 0,
    totalCourseList: 0,
    isLoading: false,
    hasMore: true,
    hasError: false,
    skipCount: 0,
    addToListBtnHover: false,
    lowProfileStatus: false,
    profileStatus: 0,
    profileLoaded: false,
    recommendDataFound: true
}


const recommendSlice = createSlice({
    name: 'recommendData',
    initialState,
    reducers: {
        setRecTab: (state, action) => {
            state.recTab = action.payload
        },
        setRecTypeTab: (state, action) => {
            state.recTypeTab = action.payload
        },
        setRecSortBy: (state, action) => {
            state.selectedRecSortBy = action.payload;
        },
        setCourseList: (state, action) => {
            state.courseList = action.payload;
        },
        setRecommendList: (state, action) => {
            state.recommendList = action.payload;
        },
        setDreamCollegeList: (state, action) => {
            state.dreamCollegeList = action.payload;
        },
        setTargetCollegeList: (state, action) => {
            state.targetCollegeList = action.payload;
        },
        setSafeCollegeList: (state, action) => {
            state.safeCollegeList = action.payload;
        },
        setTotalDreamCollegeList: (state, action) => {
            state.totalDreamCollegeList = action.payload;
        },
        setTotalTargetCollegeList: (state, action) => {
            state.totalTargetCollegeList = action.payload;
        },
        setTotalSafeCollegeList: (state, action) => {
            state.totalSafeCollegeList = action.payload;
        },
        setTotalCourseList: (state, action) => {
            state.totalCourseList = action.payload;
        },
        setRecIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setRecHasMore: (state, action: PayloadAction<boolean>) => {
            state.hasMore = action.payload;
        },
        setRecHasError: (state, action: PayloadAction<boolean>) => {
            state.hasError = action.payload;
        },
        setRecSkipCount: (state, action: PayloadAction<number>) => {
            state.skipCount = action.payload;
        },
        setAddToListBtnHover: (state, action: PayloadAction<boolean>) => {
            state.addToListBtnHover = action.payload;
        },
        setProfileStatus: (state, action: PayloadAction<number>) => {
            state.profileStatus = action.payload;
        },
        setLowProfileStatus: (state, action: PayloadAction<boolean>) => {
            state.lowProfileStatus = action.payload;
        },
        setRecShortlistData: (state, action) => {
            state.shortListData = action.payload;
        },
        setProfileLoaded: (state, action) => {
  state.profileLoaded = action.payload;
},
        setRecommendDataFound: (state, action: PayloadAction<boolean>) => {
            state.recommendDataFound = action.payload;
        },
        clearRecommendData: () => initialState
    }
})

export const {
    setRecTab,
    setRecTypeTab,
    setRecSortBy,
    setDreamCollegeList,
    setTargetCollegeList,
    setSafeCollegeList,
    setTotalDreamCollegeList,
    setTotalTargetCollegeList,
    setTotalSafeCollegeList,
    setRecIsLoading,
    setRecHasMore,
    setRecHasError,
    setRecSkipCount,
    setRecommendList,
    setAddToListBtnHover,
    setCourseList,
    setTotalCourseList,
    setProfileStatus,
    setLowProfileStatus,
    setRecShortlistData,
    setProfileLoaded,
    setRecommendDataFound,
    clearRecommendData
} = recommendSlice.actions
export default recommendSlice.reducer